import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { api, getAddressOfOrder } from "ticketino-api-client";

import logoDE from "../images/logo_de.png";
import logoFR from "../images/logo_fr.png";
import banner from "../images/banner.jpg";

import imgIconProgressGrey from "../images/progress-bar/icon-progress-grey.svg";
import imgIconProgressTick from "../images/progress-bar/icon-progress-tick.svg";
import imgIconProgress2 from "../images/progress-bar/icon-progress2.svg";

import Loading from "./components/Loading";

const Address = () => {
    const [order, setOrder] = useState({});
    const [orderId, setOrderId] = useState();
    const [organizerId, setOrganizerId] = useState(0);
    const [promotioncode] = useState(sessionStorage.getItem("addedPromotion"));
    const [selectedTicketTypeId] = useState(sessionStorage.getItem("selectedTicketTypeId"));
    const [isEmployee] = useState(sessionStorage.getItem("isEmployee"));

    const [showInvoiceAddress, setShowInvoiceAddress] = useState(false);

    const [loading, setLoading] = useState(false);

    const [buyerInfo, setBuyerInfo] = useState({
        salutation: "",
        firstName: "",
        name: "",
        function: "",
        street: "",
        city: "",
        postCode: "",
        countryId: 176,
        email: "",
        employee: "",
        confirmemail: "",
        invoiceAddressFunction: "",
        invoiceAddressCompany: "",
        invoiceAddressDepartmentReference: "",
        invoiceAddressStreet: "",
        invoiceAddressPostCode: "",
        invoiceAddressCity: ""
    });

    const employeeData = {
        AG: { street: "Suhrenmattstrasse 29", postCode: "5035", city: "Unterentfelden", emailOrganization: "buchhaltung@ag.prosenectute.ch" },
        AI: { street: "Marktgasse 10c", postCode: "9050", city: "Appenzell", emailOrganization: "esther.wyss@ai.prosenectute.ch" },
        AJ: { street: "Rue du Puits 4", postCode: "2800", city: "Del\u00E9mont", emailOrganization: "nathalie.schaller@ne.ch" },
        AR: { street: "Gossauerstrasse 2", postCode: "9100", city: "Herisau", emailOrganization: "info@ar.prosenectute.ch" },
        BB: { street: "Im Westfeld 6", postCode: "4009", city: "Basel", emailOrganization: "kreditoren@bb.prosenectute.ch" },
        BE: { street: "Worblentalstrasse 32", postCode: "3063", city: "Ittigen", emailOrganization: "kreditoren@be.prosenectute.ch" },
        FR: { street: "Passage du Cardinal 18", postCode: "1700", city: "Fribourg", emailOrganization: "info@fr.prosenectute.ch" },
        GE: { street: "Route de Saint-Julien 5 B", postCode: "1227", city: "Carouge GE", emailOrganization: "compta@ge.prosenectute.ch" },
        GL: { street: "Gerichtshausstrasse 10", postCode: "8750", city: "Glarus", emailOrganization: "info@gl.prosenectute.ch" },
        GR: { street: "Alexanderstrasse 2", postCode: "7000", city: "Chur", emailOrganization: "info@gr.prosenectute.ch" },
        LU: { street: "Maihofstrasse 76", postCode: "6002", city: "Luzern", emailOrganization: "finanzen@lu.prosenectute.ch" },
        NW: { street: "N\u00E4geligasse 25", postCode: "6370", city: "Stans", emailOrganization: "daniel.diem@nw.prosenectute.ch" },
        OW: { street: "Marktgasse 5", postCode: "6060", city: "Sarnen", emailOrganization: "info@ow.prosenectute.ch" },
        SG: { street: "Davidstrasse 16", postCode: "9001", city: "St. Gallen", emailOrganization: "valesca.montanes@sg.prosenectute.ch" },
        SH: { street: "Vorstadt 54", postCode: "8201", city: "Schaffhausen", emailOrganization: "finanzen@sh.prosenectute.ch" },
        SO: { street: "Hauptbahnhofstrasse 12", postCode: "4500", city: "Solothurn", emailOrganization: "regina.vogt@so.prosenectute.ch" },
        SZ: { street: "Bahnhofstrasse 29", postCode: "6440", city: "Brunnen", emailOrganization: "finanzen@sz.prosenectute.ch" },
        TG: { street: "Rathausstrasse 17", postCode: "8570", city: "Weinfelden", emailOrganization: "rechnungen@pstg.ch" },
        TI: { street: "Via Chiosso 17", postCode: "6948", city: "Porza", emailOrganization: "servizio.contabilita@prosenectute.org" },
        UR: { street: "Gitschenstrasse 9", postCode: "6460", city: "Altdorf UR", emailOrganization: "info@ur.prosenectute.ch" },
        VD: { street: "Rue du Maupas 51", postCode: "1004", city: "Lausanne", emailOrganization: "facture@vd.prosenectute.ch" },
        VS: { street: "Avenue de Tourbillon 19", postCode: "1950", city: "Sion", emailOrganization: "Dorothee.Follonier@vs.prosenectute.ch" },
        ZG: { street: "Aegeristrasse 52", postCode: "6300", city: "Zug", emailOrganization: "finanzen@zg.prosenectute.ch" },
        ZH: { street: "Forchstrasse 145", postCode: "8032", city: "Z\u00FCrich", emailOrganization: "buchhaltung@pszh.ch" }
    };

    // react hook for navigation
    let navigate = useNavigate();

    // base url
    let baseUrl = process.env.REACT_APP_BASEURL_API;

    // setting the base url of the npm package api calls
    api.defaults.baseURL = baseUrl;

    // fetching resources
    const [resources, setResources] = useState({});

    // fetching params
    let { language } = useParams();

    let languageId = 0;

    let logo = logoDE;

    // changing languageId according to the url
    switch (language) {
        case ("de" || "DE"):
            languageId = 1;
            break;
        case ("fr" || "FR"):
            languageId = 2;
            logo = logoFR;
            break;
        default:
            languageId = 0;
            language = "de";
            break;
    }

    useEffect(() => {
        const loadToken = async () => {
            try {
                const res = await axios.get("form/token");
                axios.defaults.headers.common["Authorization"] = "Bearer " + res.data;
                api.defaults.headers.common['Authorization'] = "Bearer " + res.data;
                await sessionStorage.setItem("token", res.data);

                requestFormSettings();
            } catch (error) {
                console.error(error);
            }
        };

        let currentOrderId = sessionStorage.getItem("orderId");

        if (currentOrderId > 0) {
            setOrderId(currentOrderId);
        }


        const requestFormSettings = async () => {
            try {
                const res = await axios.get(`form/formsettings`);

                if (currentOrderId > 0) {
                    loadOrder(currentOrderId)
                } else {
                    sessionStorage.removeItem("addedPromotion"); // clear promotion code
                    navigate(`/${language}/home`);
                }

                setOrganizerId(res.data.organizerId)
            } catch (error) {
                console.error(error);
            }
        };

        loadToken();
    }, []);

    useEffect(() => {
        if (buyerInfo.employee !== "" && employeeData[buyerInfo.employee]) {
            setBuyerInfo((prev) => ({
                ...prev,
                ...employeeData[buyerInfo.employee],
            }));
        }
    }, [buyerInfo.employee]);

    useEffect(() => {
        requestResources();
    }, [language]); //everytime language is changed


    useEffect(() => {
        if (promotioncode && promotioncode != "" && organizerId && organizerId !== 0) {
            loadAddress(promotioncode);
        }
    }, [promotioncode, organizerId]);

    const requestResources = async () => {
        await axios
            .get(`form/resources/${language}`)
            .then((res) => {
                setResources(res.data?.translation);
            })
            .catch((error) => console.error(error.response.data));
    };

    const removePromotionCode = async (promotion) => {
        try {
            const response = axios.delete(`${baseUrl}/ShopBasket/Order/${orderId}/PromotionCode/${promotion}`);
            return response.data;
        } catch (error) {
            console.error(error);
        }
    }

    const getOrderByOrderId = async (orderId) => {
        try {
            const res = await axios.get(`${baseUrl}/ShopBasket/Order/${orderId}`);
            return res.data;
        }
        catch (error) {
            console.error(error);
            if (error.response.status === 404 || error.response.status === 403) {
                navigate(`/${language}/home`);
            }
        }
    }

    const loadOrder = async (orderId) => {
        try {
            // Order
            const updatedOrder = await getOrderByOrderId(orderId);

            //if (updatedOrder != null && updatedOrder.tickets != null) {

            //    let ticketTypeIdsToRemove = updatedOrder.tickets
            //        .map(ticket => ticket.id);

            //    // DELETE request to remove tickets
            //    await axios.delete(`${baseUrl}/ShopBasket/Order/${orderId}/Tickets`, {
            //        data: { TicketsToRemove: ticketTypeIdsToRemove }
            //    });
            //}

            if (updatedOrder === null && updatedOrder.tickets === null) {
                navigate(`/${language}/home`)
            }

            setOrder(updatedOrder);
        }
        catch (error) {
            console.error(error);
        }
    }

    const loadAddress = async (code) => {
        try {
            let updatedAddress = {};

            try {
                updatedAddress = await getAddressOfPromotionCode(code, organizerId);
            } catch { }

            if (updatedAddress) {
                setBuyerInfo((prevBuyerInfo) => ({
                    ...prevBuyerInfo,
                    salutation: updatedAddress.salutation,
                    firstName: updatedAddress.firstName,
                    name: updatedAddress.name,
                    email: updatedAddress.email,
                    street: updatedAddress.street,
                    city: updatedAddress.city,
                    postCode: updatedAddress.postCode,
                    function: updatedAddress.function,
                }));
            }
        } catch (error) {
            console.error(error);
        }
    }

    const getAddressOfPromotionCode = async (promotionCode, organizerId) => {
        try {
            const res = await axios.get(`${baseUrl}/PromotionCode/${promotionCode}/Address?organizerId=${organizerId}`);
            return res.data;
        } catch (error) {
            console.error(error);
        }
    }

    const onInputChange = (e) => {
        setBuyerInfo({ ...buyerInfo, [e.target.name]: e.target.value });
    };

    const onSubmit = async () => {

        setLoading(true);

        await addAddressToBasket(buyerInfo.companion1firstname, buyerInfo.companion1lasttname);
    }

    const addAddressToBasket = async () => {

        let emailSalutation = buyerInfo.salutation;

        //workaround for german email salutation
        if (emailSalutation === "Herr") {
            emailSalutation = resources?.BuyerSalutationMrValue;
        } else if (emailSalutation === "Frau") {
            emailSalutation = resources?.BuyerSalutationMsValue;
        } else if (emailSalutation === "Divers") {
            emailSalutation = resources?.BuyerSalutationDiverseValue;
        }

        let addressBody = {
            salutation: buyerInfo.salutation,
            firstName: buyerInfo.firstName,
            name: buyerInfo.name,
            function: buyerInfo.function,
            street: buyerInfo.street,
            city: buyerInfo.city,
            postCode: buyerInfo.postCode,
            countryId: buyerInfo.countryId,
            email: buyerInfo.email,
            code1: buyerInfo.employee,
            code3: emailSalutation,
            ...(showInvoiceAddress && {
                deliveryActive: true,
                deliveryCompanyName2: buyerInfo.invoiceAddressFunction,
                deliveryCompanyName: buyerInfo.invoiceAddressCompany,
                code2: buyerInfo.invoiceAddressDepartmentReference,
                deliveryFirstName: buyerInfo.firstName,
                deliveryLastName: buyerInfo.name,
                deliveryStreet: buyerInfo.invoiceAddressStreet,
                deliveryPostCode: buyerInfo.invoiceAddressPostCode,
                deliveryCity: buyerInfo.invoiceAddressCity,
                deliveryCountryId: 176
            })
        };

        await axios
            .put(`${baseUrl}/Order/${orderId}/Address`, addressBody)
            .then(() => {

                // gtm - addAddress
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'event': 'addAddress'
                });

                navigate(`/${language}/ticket`)
            })
            .catch((error) => {
                console.error(error.response.data);
                navigate(`/${language}/home`)
            });
    };

    let validation =
        buyerInfo.salutation && /^.{1,70}$/.test(buyerInfo.salutation) &&
        buyerInfo.firstName && /^.{1,70}$/.test(buyerInfo.firstName) &&
        buyerInfo.name && /^.{1,70}$/.test(buyerInfo.name) &&
        buyerInfo.street && /^.{1,70}$/.test(buyerInfo.street) &&
        buyerInfo.postCode && /^.{1,70}$/.test(buyerInfo.postCode) &&
        buyerInfo.city && /^.{1,70}$/.test(buyerInfo.city) &&
        buyerInfo.email && /^\S+@\S+\.\S+$/.test(buyerInfo.email) &&
        buyerInfo.confirmemail && /^\S+@\S+\.\S+$/.test(buyerInfo.confirmemail) &&
        buyerInfo.email === buyerInfo.confirmemail;


    if (isEmployee) {
        if (buyerInfo.employee === "") {
            validation = false;
        }
    }

    if (showInvoiceAddress) {
        if (buyerInfo.invoiceAddressStreet === "") {
            validation = false;
        }

        if (buyerInfo.invoiceAddressPostCode === "") {
            validation = false;
        }

        if (buyerInfo.invoiceAddressCity === "") {
            validation = false;
        }
    }

    const onBackClick = async () => {
        const promotioncode = sessionStorage.getItem("addedPromotion");

        if (promotioncode?.length > 0) {
            sessionStorage.removeItem("addedPromotion"); // clear promotion code
            await removePromotionCode(promotioncode);
        }

        navigate(-1)
    }

    return (
        <div>
            {loading ? (
                <>
                    <Loading
                        alignment="center"
                        color="#d3d3d3"
                        bgColor="#fff"
                        top="50%"
                        resources={resources}
                    />
                </>
            ) : (
                <>
                    <div className="row">

                        {/* fixed image column */}
                        <div className="col-md-5 fixed-column">
                            <img className="img-fluid w-100" src={banner} alt="banner"></img>
                        </div>

                        {/* scrollable content column */}
                        <div className="col-md-7 pt-3 ps-4 pe-4 scrollable-column">
                            <div className="d-flex justify-content-end">
                                <a href="https://www.prosenectute.ch/de.html">
                                    <img className="logo" src={logo} alt="logo" href="https://www.prosenectute.ch/de.html" />
                                </a>
                            </div>

                            <div className="row mt-2">
                                <div className="col-md-12">
                                    <span className="text-title d-block">{resources?.Title}</span>
                                    <span className="text-subtitle d-block">{resources?.TitleDescription}</span>
                                </div>
                            </div>

                            {/* progress bar */}
                            <div className="progress-container mt-3">
                                <div className="progress-step active">
                                    <div>
                                        <div className="image">
                                            <img src={imgIconProgressTick} alt="Step 1" />
                                        </div>
                                        <div className="step-number text-wrap visible-desktop">{resources?.ProgressTickets}</div>
                                    </div>
                                    <div className="line"></div>
                                </div>

                                <div className="progress-step completed">
                                    <div>
                                        <div className="image">
                                            <img src={imgIconProgress2} alt=" Step 2" />
                                        </div>
                                        <div className="step-number text-wrap visible-desktop">{resources?.ProgressYourInformation}</div>
                                    </div>
                                    <div className="line"></div>
                                </div>

                                <div className="progress-step">
                                    <div>
                                        <div className="image">
                                            <img src={imgIconProgressGrey} alt="Step 3" />
                                        </div>
                                        <div className="step-number text-wrap visible-desktop">{resources?.ProgressAdditionalInformation}</div>
                                    </div>
                                    <div className="line"></div>
                                </div>

                                <div className="progress-step">
                                    <div>
                                        <div className="image">
                                            <img src={imgIconProgressGrey} alt="Step 4" />
                                        </div>
                                        <div className="step-number text-wrap visible-desktop">{resources?.ProgressCheckout}</div>
                                    </div>
                                </div>
                            </div>

                            <div className="row mt-4">
                                <div className="col-md-12">
                                    <span className="text-subtitle">{resources?.BuyerPleaseFill}</span>
                                </div>
                            </div>

                            {/* Buyer */}
                            <div className="mb-4 mt-4 row">
                                <div className="col-md-4">
                                    <label className="d-block">{resources?.BuyerSalutation}<span className="mandatory">*</span></label>
                                    <select className={`form-select mt-2`} value={buyerInfo.salutation} name="salutation" onChange={onInputChange}>
                                        <option value="">{resources?.BuyerChoose}</option>
                                        <option value={resources?.BuyerSalutationMr}>{resources?.BuyerSalutationMr}</option>
                                        <option value={resources?.BuyerSalutationMs}>{resources?.BuyerSalutationMs}</option>
                                        <option value={resources?.BuyerSalutationDiverse}>{resources?.BuyerSalutationDiverse}</option>
                                    </select>
                                </div>
                            </div>
                            <div className="mb-4 row">
                                <div className="col-md-4">
                                    <label className="d-block">{resources?.BuyerFirstname}<span className="mandatory">*</span></label>
                                    <input
                                        type="text"
                                        name="firstName"
                                        className="form-control mt-2"
                                        value={buyerInfo.firstName}
                                        id="firstName"
                                        onChange={onInputChange}
                                    />
                                </div>
                                <div className="col-md-4 mt-4 mt-md-0">
                                    <label className="d-block">{resources?.BuyerLastname}<span className="mandatory">*</span></label>
                                    <input
                                        type="text"
                                        name="name"
                                        className="form-control mt-2"
                                        value={buyerInfo.name}
                                        id="name"
                                        onChange={onInputChange}
                                    />
                                </div>
                            </div>

                            <div className="mb-4 row">
                                <div className="col-md-4">
                                    <label className="d-block">{resources?.BuyerFunction}</label>
                                    <input
                                        type="text"
                                        name="function"
                                        className="form-control mt-2"
                                        value={buyerInfo.function}
                                        id="function"
                                        onChange={onInputChange}
                                    />
                                </div>
                            </div>

                            {isEmployee &&
                                <div className="mb-4 mt-4 row">
                                    <label className="d-block">{resources?.BuyerEmployee1}<span className="mandatory">*</span></label>
                                    <label className="d-block">{resources?.BuyerEmployee2}</label>
                                    <div className="col-4">
                                        <select className="form-select mt-2" value={buyerInfo.employee} name="employee" onChange={onInputChange}>
                                            <option value="" disabled>{resources?.BuyerChoose}</option>
                                            {Object.keys(employeeData).map((key) => (
                                                <option key={key} value={key}>{key}</option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                            }

                            <div className="mb-4 row">
                                <div className="col-md-4">
                                    <label className="d-block">{resources?.BuyerStreet}<span className="mandatory">*</span></label>
                                    <input
                                        type="text"
                                        name="street"
                                        className="form-control mt-2"
                                        value={buyerInfo.street}
                                        id="street"
                                        onChange={onInputChange}
                                    />
                                </div>
                            </div>

                            <div className="mb-4 row">
                                <div className="col-4 col-md-2">
                                    <label className="d-block">{resources?.BuyerPostcode}<span className="mandatory">*</span></label>
                                    <input
                                        type="text"
                                        name="postCode"
                                        className="form-control mt-2"
                                        value={buyerInfo.postCode}
                                        id="postCode"
                                        onChange={onInputChange}
                                    />
                                </div>

                                <div className="col-8 col-md-4">
                                    <label className="d-block">{resources?.BuyerCity}<span className="mandatory">*</span></label>
                                    <input
                                        type="text"
                                        name="city"
                                        className="form-control mt-2"
                                        value={buyerInfo.city}
                                        id="city"
                                        onChange={onInputChange}
                                    />
                                </div>
                            </div>

                            {/* Invoice address */}
                            <div className="mb-4 row">
                                <div className="col-md-12 d-flex align-items-center">
                                    <input
                                        type="checkbox"
                                        className="form-check-input me-2"
                                        id="invoiceAddress"
                                        onChange={(e) => setShowInvoiceAddress(e.target.checked)}
                                    />
                                    <label className="mt-1" htmlFor="invoiceAddress">{resources?.BuyerInvoiceAddress}</label>
                                </div>
                            </div>

                            {showInvoiceAddress &&
                                <>
                                    <div className="mb-4 row">
                                        <div className="col-md-4">
                                            <label className="d-block">{resources?.BuyerFunction}</label>
                                            <input
                                                type="text"
                                                name="invoiceAddressFunction"
                                                className="form-control mt-2"
                                                value={buyerInfo.invoiceAddressFunction}
                                                id="invoiceAddressFunction"
                                                onChange={onInputChange}
                                            />
                                        </div>
                                    </div>

                                    <div className="mb-4 row">
                                        <div className="col-md-4">
                                            <label className="d-block">{resources?.BuyerPronectuteCompany}</label>
                                            <input
                                                type="text"
                                                name="invoiceAddressCompany"
                                                className="form-control mt-2"
                                                value={buyerInfo.invoiceAddressCompany}
                                                id="invoiceAddressCompany"
                                                onChange={onInputChange}
                                            />
                                        </div>
                                    </div>

                                    <div className="mb-4 row">
                                        <div className="col-md-4">
                                            <label className="d-block">{resources?.BuyerDepartmentReference}</label>
                                            <input
                                                type="text"
                                                name="invoiceAddressDepartmentReference"
                                                className="form-control mt-2"
                                                value={buyerInfo.invoiceAddressDepartmentReference}
                                                id="invoiceAddressDepartmentReference"
                                                onChange={onInputChange}
                                            />
                                        </div>
                                    </div>

                                    <div className="mb-4 row">
                                        <div className="col-md-4">
                                            <label className="d-block">{resources?.BuyerStreet}<span className="mandatory">*</span></label>
                                            <input
                                                type="text"
                                                name="invoiceAddressStreet"
                                                className="form-control mt-2"
                                                value={buyerInfo.invoiceAddressStreet}
                                                id="invoiceAddressStreet"
                                                onChange={onInputChange}
                                            />
                                        </div>
                                    </div>

                                    <div className="mb-4 row">
                                        <div className="col-4 col-md-2">
                                            <label className="d-block">{resources?.BuyerPostcode}<span className="mandatory">*</span></label>
                                            <input
                                                type="text"
                                                name="invoiceAddressPostCode"
                                                className="form-control mt-2"
                                                value={buyerInfo.invoiceAddressPostCode}
                                                id="invoiceAddressPostCode"
                                                onChange={onInputChange}
                                            />
                                        </div>

                                        <div className="col-8 col-md-4">
                                            <label className="d-block">{resources?.BuyerCity}<span className="mandatory">*</span></label>
                                            <input
                                                type="text"
                                                name="invoiceAddressCity"
                                                className="form-control mt-2"
                                                value={buyerInfo.invoiceAddressCity}
                                                id="invoiceAddressCity"
                                                onChange={onInputChange}
                                            />
                                        </div>
                                    </div>
                                </>
                            }

                            {/* email */}
                            <div className="mb-4 row">
                                <div className="col-md-4">
                                    <label className="d-block">{resources?.BuyerEmail}<span className="mandatory">*</span></label>
                                    <input
                                        type="text"
                                        name="email"
                                        className="form-control mt-2"
                                        value={buyerInfo.email}
                                        id="email"
                                        onChange={onInputChange}
                                    />
                                </div>
                                <div className="col-md-4 mt-4 mt-md-0">
                                    <label className="d-block">{resources?.BuyerConfirmEmail}<span className="mandatory">*</span></label>
                                    <input
                                        type="text"
                                        name="confirmemail"
                                        className="form-control mt-2"
                                        value={buyerInfo.confirmemail}
                                        id="confirmemail"
                                        onChange={onInputChange}
                                    />
                                </div>
                            </div>

                            <div className="row mt-5 mb-4">
                                {/*<div className=" col-6 text-start">*/}
                                {/*    <button className="btn button-custom" onClick={onBackClick}>*/}
                                {/*        {resources?.Back}*/}
                                {/*    </button>*/}
                                {/*</div>*/}
                                <div className="col-6 text-end">
                                    <button className="btn button-custom" disabled={!validation} onClick={onSubmit}>{resources.Next}</button>
                                </div>
                            </div>
                            {buyerInfo.email !== buyerInfo.confirmemail && buyerInfo.confirmemail.length > 0 &&
                                <div className="row">
                                    <div className="col-12 text-end">
                                        <span className="error">{resources?.BuyerErrorPasswordMismatch}</span>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </>
            )}
        </div>
    )
}

export default Address